import React from 'react'
import Paper from '@mui/material/Paper'
import Box from '@mui/material/Box'
import { MobilePageTabBar } from 'components/MobilePageTabBar'
import { BOTTOM_NAV_HEIGHT, BRAND_NAVY, SAFE_AREA_BOTTOM } from 'core/theme.tokens'
import { usePageTabsContext } from 'contexts/PageTabsContext'

/**
 * Phone bottom bar. Renders the tabs the current page registered via
 * `MobileTabSelect` / `useRegisterPageTabs`. Global navigation is not here — it
 * lives in the hamburger drawer. Renders nothing when the page has no tabs.
 */
export const CoreBottomNav: React.FC = () => {
  const ctx = usePageTabsContext()
  const config = ctx?.config

  if (!config || config.tabs.length === 0) {
    return null
  }

  return (
    <Paper
      elevation={0}
      square
      sx={{
        display: 'block',
        position: 'fixed',
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: theme => theme.zIndex.appBar,
        borderRadius: 0,
        overflow: 'hidden',
        pb: 0,
        minHeight: `calc(${BOTTOM_NAV_HEIGHT}px + ${SAFE_AREA_BOTTOM})`,
        bgcolor: BRAND_NAVY,
        borderTop: '1px solid',
        borderColor: 'rgba(244, 241, 235, 0.18)',
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'stretch', width: '100%', minHeight: 'inherit' }}>
        <MobilePageTabBar
          tabs={config.tabs}
          value={config.value}
          onChange={config.onChange}
          ariaLabel={config.ariaLabel}
          label={config.label}
        />
      </Box>
    </Paper>
  )
}
